import { z } from "zod";

const CodiDetailsSchema = z
  .object({
    resultado: z.boolean().nullable().optional(),
    status: z.string().nullable().optional(),
    ref_pago: z.string().optional().nullable(),
    json_pago: z.string().optional().nullable(),
    msg: z.string().optional().nullable(),
    clave_rastreo: z.string().optional().nullable(),
  })
  .transform((api) => ({
    result: api.resultado,
    status: api.status,
    reference: api.ref_pago,
    image: api.json_pago,
    error: api.msg,
    trackCode: api.clave_rastreo,
  }));

type CodiDetails = z.infer<typeof CodiDetailsSchema>;

export { CodiDetailsSchema, type CodiDetails };
